import { InteractionBubbles as InteractionBubbles$1 } from '@hse-design/core';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import 'reflect-metadata';

var InteractionBubbles = /** @class */ (function (_super) {
    __extends(InteractionBubbles, _super);
    function InteractionBubbles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.interactionBubbles = InteractionBubbles$1.create();
        return _this;
    }
    InteractionBubbles.prototype.beforeDestroy = function () {
        this.interactionBubbles.onWillUnmount();
    };
    InteractionBubbles.prototype.mounted = function () {
        this.bubblesUpdate();
    };
    InteractionBubbles.prototype.updated = function () {
        this.bubblesUpdate();
    };
    Object.defineProperty(InteractionBubbles.prototype, "enabled", {
        get: function () {
            return !this.disabled && !this.inactive;
        },
        enumerable: false,
        configurable: true
    });
    InteractionBubbles.prototype.bubblesUpdate = function () {
        this.interactionBubbles.update({
            root: this.$refs.bubbleRoot,
            enabled: this.enabled
        });
    };
    InteractionBubbles.prototype.onClick = function (e) {
        this.interactionBubbles.onClick();
        if (this.enabled)
            this.$emit('click', e);
    };
    InteractionBubbles.prototype.onMouseDown = function () {
        this.interactionBubbles.onMouseDown();
    };
    InteractionBubbles.prototype.onKeyDown = function (e) {
        this.interactionBubbles.onKeyDown(e);
    };
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], InteractionBubbles.prototype, "disabled", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], InteractionBubbles.prototype, "inactive", void 0);
    InteractionBubbles = __decorate([
        Component({
            name: 'InteractionBubbles'
        })
    ], InteractionBubbles);
    return InteractionBubbles;
}(Vue));

export default InteractionBubbles;
